<template>
    <div class="brief">
        <div class="row">
            <!-- 左边 -->
            <div class="fl w235">
                <div class="sideTitle2">
                    <div class="list-img">
                        <h5>下载中心</h5>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in list" ref="boxll" :class="isActive == index?'active': ''"
                                :key="index" @click="listClick(item.id,index)">
                                <p>{{item.text}}</p>
                                <i class="el-icon-arrow-right"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sideImg">
                    <img src="../../../../assets/image/mxu.jpg" alt="">
                </div>
            </div>
            <!-- 右边 -->
            <div class="fr w750">
                <div class="pageBox2">
                    <div class="about">
                        <!-- <div class="title">{{getData.title}}</div>
                        <p>{{getData.updateTime}}</p> -->
                        <div class="title">{{getData.title}}</div>
                        <div class="text-cell">
                            <ul>
                                <li>
                                    <p>时间：{{getData.createTime}}</p>
                                </li>
                                <li>
                                    <p>来源：{{getData.source}}</p>
                                </li>
                                <li>
                                    <p>编辑: {{getData.editor}}</p>
                                </li>
                                <li>
                                    <p>点击次: {{getData.hits}}</p>
                                </li>
                                <li>
                                    <p>字体: </p>
                                    <p>
                                        <span v-for="(item,index) in fontSize" :key="item.id"
                                            :class="asActive==index ? 'active' : '' "
                                            @click="fontSizeClick(item.id,index)">
                                            {{item.textSize}}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <el-divider></el-divider>
                        <div class="content ql-editor" ref="box" v-html="getData.content"></div>
                        <el-divider></el-divider>
                        <div class="ann-file" v-for="item in getData.annexes" :key="item.id">
                            <a class="colorall" :href="item.fileUrl">附件：{{item.fileName}}</a>
                        </div>
                        <div class="ann-file" v-show="getData.attchment" v-for="item in JSON.parse(getData.attchment)" :key="item.url">
                            <a class="colorall" :href="item.url">附件：{{item.fileName}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                getData: '',
                id: this.$route.query.id,
                asActive: 1,
                isActive: this.$route.query.isActive,
                fontSize: [{
                    textSize: '大',
                    id: 1
                }, {
                    textSize: '中',
                    id: 2
                }, {
                    textSize: '小',
                    id: 3
                }],
                list: [{
                        text: '协会文件',
                        id: 1
                    },
                    {
                        text: '行业资料',
                        id: 2
                    }
                ]
            }
        },
        mounted() {
            this.getlist();
        },
        methods: {
            // 获取协会公告的详情数据
            getlist() {
                this.$axios.get('/websiteData/title/getOne/' + this.id).then(res => {
                    this.getData = res.data.data;
                })
            },
            // 设置字体的大小
            fontSizeClick(id, index) {
                this.asActive = index;
                if (id == 1) {
                    this.$refs.box.style.fontSize = '16px'
                } else if (id == 2) {
                    this.$refs.box.style.fontSize = '14px'
                } else if (id == 3) {
                    this.$refs.box.style.fontSize = '12px'
                }
            },
            listClick(id) {
                if (id == 1) {
                    this.$router.push({
                        path: '/industryNews',
                    })
                } else if (id == 2) {
                    this.$router.push({
                        path: '/associationNews',
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .brief {
        margin: 20px 0;
        overflow: hidden;

        .row {
            width: 1000px;
            background-color: #FFF;
            margin: 0 auto;

            .w235 {
                width: 235px;
                left: -8px;

                .sideImg {
                    text-align: center;
                    padding: 20px 0;
                }
            }

            .w750 {
                width: 750px;
                position: relative;
                right: -7px;

                .pageBox2 {
                    min-height: 830px;
                    border: 1px #DDDDDD solid;
                    border-radius: 5px;
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
                        0 0 6px 0 rgba(0, 0, 0, 0.04);

                    .about {
                        padding: 45px 35px;
                        line-height: 20px;
                        text-align: justify;

                        p {
                            text-align: right;

                        }

                        .title {
                            line-height: 30px;
                            text-align: center;
                            padding-bottom: 35px;
                        }
                    }
                }
            }
        }
    }
</style>